// extracted by mini-css-extract-plugin
export var modal = "_ft-0";